module.exports = __webpack_public_path__ + "img/hv.56a38f36.png";